
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93mKhrQ6y8BgBFOXRa2iZG0xMgzNUkkOYvDnBX50FZsJIMeta } from "/usr/src/app/pages/[...slug].vue?macro=true";
import { default as indexQkfZdo6ZiMAGDgtzvRa1sZcdkd0247XFY9i8BP3Ps_45oMeta } from "/usr/src/app/pages/account/index.vue?macro=true";
import { default as _91_46_46_46slug_93y_xfecBbeGKcpoVQQ42MmTHKYqNGZHEEA7QAzG1igcAMeta } from "/usr/src/app/pages/cart/[...slug].vue?macro=true";
import { default as indexMoRJ68d_45GisCGWiVNfTDmv1uh1JPvTCfF28ZHoFDipAMeta } from "/usr/src/app/pages/products/index.vue?macro=true";
import { default as component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta } from "/usr/src/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@18.19.110_db0@0.3.2_eslint@8.57.1_ioredis_6ac6152ddbe04f5c7a77fce25be1b3d6/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E } from "/usr/src/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@18.19.110_db0@0.3.2_eslint@8.57.1_ioredis_6ac6152ddbe04f5c7a77fce25be1b3d6/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___de_AT",
    path: "/de_AT/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___de_DE",
    path: "/de_DE/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___de_CH",
    path: "/de_CH/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr_CH",
    path: "/fr_CH/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr_FR",
    path: "/fr_FR/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___sv",
    path: "/sv/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___sv_SE",
    path: "/sv_SE/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___da",
    path: "/da/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___da_DK",
    path: "/da_DK/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___nl_NL",
    path: "/nl_NL/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___en_GB",
    path: "/en_GB/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___en_US",
    path: "/en_US/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___en_INT",
    path: "/en_INT/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "account___de",
    path: "/de/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___de_AT",
    path: "/de_AT/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___de_DE",
    path: "/de_DE/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___de_CH",
    path: "/de_CH/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___fr",
    path: "/fr/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___fr_CH",
    path: "/fr_CH/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___fr_FR",
    path: "/fr_FR/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___sv",
    path: "/sv/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___sv_SE",
    path: "/sv_SE/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___da",
    path: "/da/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___da_DK",
    path: "/da_DK/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___nl",
    path: "/nl/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___nl_NL",
    path: "/nl_NL/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___en_GB",
    path: "/en_GB/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___en_US",
    path: "/en_US/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___en_INT",
    path: "/en_INT/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "cart-slug___de",
    path: "/de/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___de_AT",
    path: "/de_AT/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___de_DE",
    path: "/de_DE/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___de_CH",
    path: "/de_CH/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___fr",
    path: "/fr/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___fr_CH",
    path: "/fr_CH/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___fr_FR",
    path: "/fr_FR/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___sv",
    path: "/sv/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___sv_SE",
    path: "/sv_SE/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___da",
    path: "/da/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___da_DK",
    path: "/da_DK/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___nl",
    path: "/nl/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___nl_NL",
    path: "/nl_NL/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___en",
    path: "/en/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___en_GB",
    path: "/en_GB/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___en_US",
    path: "/en_US/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___en_INT",
    path: "/en_INT/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "products___de",
    path: "/de/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___de_AT",
    path: "/de_AT/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___de_DE",
    path: "/de_DE/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___de_CH",
    path: "/de_CH/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___fr",
    path: "/fr/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___fr_CH",
    path: "/fr_CH/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___fr_FR",
    path: "/fr_FR/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___sv",
    path: "/sv/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___sv_SE",
    path: "/sv_SE/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___da",
    path: "/da/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___da_DK",
    path: "/da_DK/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___nl",
    path: "/nl/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___nl_NL",
    path: "/nl_NL/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___en",
    path: "/en/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___en_GB",
    path: "/en_GB/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___en_US",
    path: "/en_US/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: "products___en_INT",
    path: "/en_INT/products",
    component: () => import("/usr/src/app/pages/products/index.vue")
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/de_AT/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/de_DE/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/de_CH/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/fr_CH/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/fr_FR/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/sv/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/sv_SE/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/da/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/da_DK/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/nl_NL/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/en_GB/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/en_US/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  },
  {
    name: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8EMeta?.name,
    path: "/en_INT/sitemap.xml",
    component: component_45stubIMYmvDOj3hfOhxV1jJ0_45xr9v44DKoRzKFQZ0LfLLR8E
  }
]